import Card from './Card';

import type { Survey, User } from '@/types';

import {
  useGetSurveysQuery,
  useGetSurveyTemplatesQuery,
} from '@/store/api/surveyApi';



interface TemplateCardsProps {
  subjectUser: User;
}

const TemplateCards = ({ subjectUser }: TemplateCardsProps) => {
  const { data: templates } = useGetSurveyTemplatesQuery(
    { userId: subjectUser.id },
    { skip: !subjectUser.id },
  );

  const { data: surveys } = useGetSurveysQuery(
    { userId: subjectUser.id },
    { skip: !subjectUser.id },
  );

  if (!subjectUser.id || !templates || !surveys) return null;

  const coachName = subjectUser.coaches[0]?.fullName ?? '';
  const surveyLookup = surveys.reduce((acc: Record<string, Survey>, survey) => {
    // API returns newest first; keep the latest survey for each template.
    if (!acc[survey.surveyTemplateId]) {
      acc[survey.surveyTemplateId] = survey;
    }
    return acc;
  }, {});

  return (
    <div className="flex flex-col space-y-4">
      {templates.map((template) => (
        <Card
          key={`survey-template-card-${template.id}`}
          coach={coachName}
          survey={surveyLookup[template.id]}
          {...template}
        />
      ))}
    </div>
  );
};

export default TemplateCards;
